import React from "react";
import SCPactometroBarras from "./pactometroBarras.js";
import { PropTypes, oneOf, shape, node, number, string, arrayOf } from "prop-types";
export const PactometroBarrasSimple = ({
  data,
  totalSeat,
  selecteds,
  centerProps,
  title,
  height
}) => {
  const selectedData = data.filter(item => selecteds.some(select => select === item.id));

  const _selectedData$reduce = selectedData.reduce((ac, current) => ({
    seat: ac.seat + current.seats,
    percent: ac.percent + current.percent
  }), {
    seat: 0,
    percent: 0
  }),
        seat = _selectedData$reduce.seat;

  return React.createElement(SCPactometroBarras, {
    height: height,
    className: "bloque-pactometro-container"
  }, React.createElement("div", {
    className: "bloque-pactometro"
  }, React.createElement("p", {
    className: "total-pactometro"
  }, title ? title : React.createElement(React.Fragment, null, "Total Esca\xF1os:", " ", React.createElement("span", {
    id: "",
    className: "total-pactometro-value"
  }, seat))), React.createElement("div", {
    id: "barra",
    className: "porcentaje-pactometro bloque-pactometro-barra"
  }, React.createElement("div", {
    className: "mayoria-pactometro-barras ".concat(centerProps.position, " ").concat(centerProps.lineStyle)
  }, React.createElement("p", null, centerProps.text || React.createElement(React.Fragment, null, "Mayor\xEDa absoluta: (", parseInt(totalSeat / 2, 0) + 1, ")"))), selectedData.map(element => React.createElement("div", {
    className: "partido",
    key: element.partyAcronym,
    title: element.partyAcronym,
    style: {
      width: "".concat(100 / totalSeat * element.seats, "%"),
      backgroundColor: element.partyColor
    }
  }, element.seat)))));
};
PactometroBarrasSimple.defaultProps = {
  centerProps: {
    position: "down",
    lineStyle: "dashed"
  },
  height: 30
};
PactometroBarrasSimple.propTypes = {
  height: number,
  title: oneOf([node, string]),
  data: arrayOf(shape({
    partyAcronym: string.isRequired,
    seats: number.isRequired,
    partyColor: string.isRequired,
    id: number.isRequired
  })).isRequired,
  selecteds: arrayOf(PropTypes.string),
  totalSeat: number.isRequired,
  centerProps: shape({
    position: oneOf(["up", "down"]),
    lineStyle: oneOf(["dashed", "solid"]),
    text: oneOf([string, node])
  })
};
export default PactometroBarrasSimple;